<template>
  <div class="container px-4">
    <div class="px-4 py-20">
      <Sidebar></Sidebar>
      <Header>{{$t('all.homepage')}}</Header>

      <div v-if="kidsMy.length > 0">
        <h4 class="text-center block rounded-full my-2 py-2 px-6 bg-blue-dark text-white hover:text-white align-middle">{{$t('all.kids_my_kids')}}</h4>
        <Minore
          v-for="minor in kidsMy"
          :minor="minor"
          :key="minor.id"
        >
          <div slot="role">{{$t('all.parent')}}</div>
          <div slot="classroom"></div>
        </Minore>
      </div>
      <div v-if="kidsOther.length > 0">
        <h4 class="text-center block rounded-full my-2 py-2 px-6 bg-blue-dark text-white hover:text-white align-middle">{{$t('all.kids_other_kids')}}</h4>
        <Minore
          v-for="minor in kidsOther"
          :minor="minor"
          :key="minor.id"
        >
          <div slot="role">{{$t('all.parent')}}</div>
          <div slot="classroom"></div>
        </Minore>
      </div>
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      users: 'users/users',
      kidsOther: 'users/kidsOther',
      kidsMy: 'users/kidsMy',
    }),
  },
  methods: {
    ...mapActions('users', ['getAll']),
  },
  beforeRouteLeave(to, from, next) {
    if (to.name !== 'Login') {
      next();
    } else if (to.query && to.query.action === 'logout') {
      next();
    } else {
      next(false);
    }
  },
  created() {
    const _this = this;
    _this.getAll();
    setInterval(() => {
      _this.getAll();
    }, 5000);
  },
};
</script>
